import React, { useState } from "react";
import { BiHide, BiShowAlt } from "react-icons/bi";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import { useGoogleLogin } from "@react-oauth/google";
import MirageLoader from "../../components/ui/pageLoader/MirageLoader";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUrl = window.location.href;

  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [password, setPassword] = useState("");
  const [emailPhoneError, setEmailPhoneError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  const orgSchemeData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "I4invest",
    url: "https://i4invest.in/",
    logo: "https://i4invest.in/images/logo.png",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91-9769699957",
      contactType: "customer service",
      contactOption: "TollFree",
      areaServed: "IN",
      availableLanguage: "en",
    },
  };

  const handleSubmit = async (e) => {
    setIsButtonClicked(true);
    let user = {};
    e.preventDefault();

    // Validate email/phone and password fields before submitting the form
    if (/^\d{10}$/.test(emailOrPhone)) {
      user = {
        email: null,
        phone: emailOrPhone,
      };
    } else if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(emailOrPhone)) {
      user = {
        email: emailOrPhone,
        phone: null,
      };
    } else {
      user = {
        email: null,
        phone: null,
      };
      setIsButtonClicked(false);
      setEmailPhoneError("Please Enter Valid Mobile or Email");
    }
    if (user?.email || user?.phone) {
      const { islogin, workingFin } = await login("api/user/login", user);

      if (islogin) {
        sessionStorage.setItem("LicenseAvailable", "YES")
        if (workingFin !== "None") {
          navigate("/UzAJ/y4fN/kdSuVuxGEcEw==", {
            replace: true,
            state: {
              workingFinYear: true,
              permittedFyList: true,
              brokerApi: true,
            },
          });
        } else {
          navigate("/4+auqlEsBqV3C7C29/79dA==", { replace: true });
        }
        setIsButtonClicked(false);
      } else {
      }
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // login
  const login = async (url, user) => {
    try {
      const response = await axios({
        method: "post",
        url: process.env.REACT_APP_API_URL + url,
        data: {
          email: user.email,
          mobile: user.phone,
          password: password,
        },
      });

      if (response.data.status_code === 200) {
        dispatch({
          type: "setAuthToken",
          payload: {
            token: response.data.data.token.access,
          },
        });

        dispatch({
          type: "setUserData",
          payload: {
            userId: response.data.data.user.id,
            first_name: response.data.data.user.first_name,
            last_name: response.data.data.user.last_name,
            email: response.data.data.user.email,
            mobile: response.data.data.user.mobile,
            password: response.data.data.user.password,
            password2: response.data.data.user.password2,
            pin_code: response.data.data.user.pin_code,
            city: response.data.data.user.city,
            state: response.data.data.user.state,
            pan_card: response.data.data.user.pan_card,
            address_line_1: response.data.data.user.address_line_1,
            address_line_2: response.data.data.user.address_line_2,
          },
        });

        const workingFin = response?.data?.data?.working_fin_year_from;
        const permissions = response?.data?.data?.Access_Permissions;
        sessionStorage.setItem("Permissions", JSON.stringify(permissions));

        // return true, workingFin;
        const islogin = true;

        return { islogin, workingFin };
      } else if (response.data.data === null) {
        setIsButtonClicked(false);
        setEmailPhoneError(response.data.message);
        return false;
      }
    } catch (err) {
      console.log(err);
      setIsButtonClicked(false);
      return false;
    }
  };
  // GOOGLE LOGIN
  const loginGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => console.log(codeResponse),
    flow: "auth-code",
  });

  return (
    <div className="w-full bg-[#ffffff] px-4 pb-[80px] pt-[130px]">
      <Helmet>
        <link rel="canonical" href={currentUrl} />
        <title>Login | I4Invest</title>
        <meta
          name="description"
          content="Access your I4Invest account to manage your portfolio, track mutual funds, and stay updated on your investments anytime, anywhere."
        />
        <meta
          property="og:image"
          content="https://i4invest.in/logo_i4invest-01.png"
        />
        <meta name="robots" content="index, follow" />
        <script type="application/ld+json">
          {JSON.stringify(orgSchemeData)}
        </script>
      </Helmet>
      <div className="mx-auto max-w-[1235px] px-[16px] md:px-0">
        <div className="flex flex-wrap items-start justify-between md:flex-nowrap">
          <div className="w-full md:w-[322px]">
            <h2 className="pb-[30px] font-open text-[24px] font-[700] leading-[36px] text-[#1E1E1E]">
              Login
            </h2>
            <form onSubmit={handleSubmit}>
              <div className="mb-[12px]">
                <p className="font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E]">
                  Email Address/Phone Number*
                </p>
                <input
                  className="mb-2 mt-[12px] w-full rounded-[8px] border border-[#B6B6B6] bg-[#F7F7F7] px-[16px] py-[12px] font-open text-[16px] font-[400] leading-[24px] text-[#999696] outline-0"
                  placeholder="Email or Phone"
                  value={emailOrPhone}
                  required
                  onChange={(e) => setEmailOrPhone(e.target.value)}
                  autoComplete="off"
                />
                {emailPhoneError && (
                  <span className="error-for">{emailPhoneError}</span>
                )}
              </div>
              <div className="mb-[12px]">
                <div className="visible-icons">
                  <p className="font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E]">
                    Password*
                  </p>
                  <input
                    className="mb-2 mt-[12px] w-full rounded-[8px] border border-[#B6B6B6] bg-[#F7F7F7] px-[16px] py-[12px] font-open text-[16px] font-[400] leading-[24px] text-[#999696] outline-0"
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    required
                    onChange={(e) => setPassword(e.target.value)}
                  />

                  <button
                    className="visib-icns"
                    type="button"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <BiShowAlt /> : <BiHide />}
                  </button>
                  {passwordError && (
                    <span className="error">{passwordError}</span>
                  )}
                </div>
              </div>
              <div>
                <Link
                  className="font-open text-[16px] font-[400] leading-[24px] text-[#428DCB] underline "
                  to="/forget-password"
                >
                  Forgot Password
                </Link>
              </div>

              <button
                className={` ${
                  isButtonClicked && "opacity-[70%]"
                } mt-[50px] w-full cursor-pointer rounded-[6px] bg-pri-clr-orange px-[24px] py-[10px] font-open text-[16px] font-[600] tracking-[0.003px] text-[#ffffff] hover:bg-[#A94829] md:px-[32px] md:py-[13px]`}
                type="submit"
                disabled={isButtonClicked}
              >
                {isButtonClicked ? <MirageLoader /> : "LOGIN"}
              </button>
            </form>
          </div>
          <div className="pt-[40px] md:pt-0">
            <h2 className="text-center font-open text-[30px] font-[700] uppercase leading-[40px] text-[#231C42] md:text-[40px] md:leading-[60px]">
              Invest{" "}
              <span className="inline-block md:block">With Confidence</span>
            </h2>
            <p className="mx-auto w-full pt-[10px] text-center font-open text-[14px] font-[600] leading-[24px] text-[#B6B6B6] md:w-[347px]">
              Unlock Your Investment Potential with Precision Portfolio
              Management
            </p>
            <div>
              <img
                className="w-full"
                src="images/Financial-growth.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
